import { render, staticRenderFns } from "./applicationCenter.vue?vue&type=template&id=b8520d52&scoped=true"
import script from "./applicationCenter.vue?vue&type=script&lang=js"
export * from "./applicationCenter.vue?vue&type=script&lang=js"
import style0 from "./applicationCenter.vue?vue&type=style&index=0&id=b8520d52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8520d52",
  null
  
)

export default component.exports